import Dialog from "dialog";
import template from "../html/dialog-new.html";
import css from "../css/dialog-new.css";

import {DateTimePicker} from "picker";


class EditDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-editdialog", EditDialog);
	}
	constructor(id) {
		super();

		server.rcall("RM_fermentation_load", id).then(function(result) {
			this.show();

			this._textboxID.value = id;
			this._textboxTargetTemperature.value = result.targetTemperature;
			this._textboxTargetPH.value = result.targetPH;
			this._textboxFeedRate.value = result.feedRate;
			this._textboxOxygenLevel.value = result.oxygenLevel;
			this.datetimepickerEndDate.value = result.endDate;
			this._checkboxRunning.checked = result.running;
		}.bind(this)).catch(function(result) {
			alert(result);
		}.bind(this));
	}
	buttonSave_click(event) {
		server.rcall("RM_fermentation_save", {
			id:			this._textboxID.value,
			targetTemperature:	this._textboxTargetTemperature.value,
			targetPH:		this._textboxTargetPH.value,
			feedRate:		this._textboxFeedRate.value,
			oxygenLevel:		this._textboxOxygenLevel.value,
			endDate:		this.datetimepickerEndDate.value,
			running:		this._checkboxRunning.checked
		}).then(function(result) {
			this.close();
		}.bind(this)).catch(function(result) {
			alert(result);
		}.bind(this));
	}
	buttonClose_click(event) {
		this.close();
	}
}

EditDialog.constructor();

export default EditDialog;